import { createAction } from '@reduxjs/toolkit';

export const clickedAd = createAction('banner/clickedAd');

export const disabledUntil = createAction<number>('banner/disabledUntil');
